export const BREEDER_PARTNERSHIP_ALERT_PERSIST_HOURS = 1;
